import { render } from "./ChatbotMessage.vue?vue&type=template&id=0c1f0ccf&scoped=true&ts=true"
import script from "./ChatbotMessage.vue?vue&type=script&lang=ts"
export * from "./ChatbotMessage.vue?vue&type=script&lang=ts"

import "./ChatbotMessage.vue?vue&type=style&index=0&id=0c1f0ccf&lang=css"
import "./ChatbotMessage.vue?vue&type=style&index=1&id=0c1f0ccf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1f0ccf"]])

export default __exports__